/****************************************************
 *
 * SimpleSelector
 *
 * @copyright Zooma 2018
 *
 */

function SimpleSelector() {

		this._opts = {
            selector        : '.SimpleSelector',
            btnSelector     : '.SimpleSelector-btn',
            listSelector    : '.SimpleSelector-list',
            expandClass     : 'is-expanded',
            bodyExpandClass : 'simple-selector-expanded' // The body class can be used to apply styles when a selector is expanded
        }; 
        this._$win         = $(window);
        this._$html        = $('html');
        this._$body        = $('body');
        this._$selectors   = $(this._opts.selector); // this asks for the class SimpleSelector

        this._init = function _init(){

            if (this._$selectors.length) {
                
                this._$selectors.each(function(index) {
                    $(this).attr('data-selector-index', index)
                })
                
                this._updateEvents()
            }
        } // end _init function

        this._updateEvents = function _updateEvents() {
            var _this = this;

          
            this._$selectors.each(function(){
                const $selector = $(this);

                

                $(this).find(_this._opts.btnSelector)
                    .off('click')
                    .on('click', function(e) {
                    
                        if ($selector.hasClass(_this._opts.expandClass)) {
                            _this._$body.removeClass(_this._opts.bodyExpandClass)
                            $selector.removeClass(_this._opts.expandClass)
                            document.removeEventListener('click', _this._outsideClickListener)
                        }else {
                            _this._collapseAll(false)
                            _this._$body.addClass(_this._opts.bodyExpandClass)
                            $selector.addClass(_this._opts.expandClass)
                            document.addEventListener('click', _this._outsideClickListener)
                        }
                        e.preventDefault()
                    })
            })
        } // end _updateEvents function

        this._outsideClickListener = function _outsideClickListener(event) {

            console.log('click')

            this._opts = {
                selector        : '.SimpleSelector',
                btnSelector     : '.SimpleSelector-btn',
                listSelector    : '.SimpleSelector-list',
                expandClass     : 'is-expanded',
                bodyExpandClass : 'simple-selector-expanded' // The body class can be used to apply styles when a selector is expanded
            }; 
            this._$win         = $(window);
            this._$html        = $('html');
            this._$body        = $('body');
            this._$selectors   = $(this._opts.selector); // this asks for the class SimpleSelector
           
            if (!$(event.target).closest(this._opts.selector).length && this._$body.hasClass(this._opts.bodyExpandClass)) {
                this._$selectors.removeClass(this._opts.expandClass)
                this._$body.removeClass(this._opts.bodyExpandClass)
                document.removeEventListener('click', this._outsideClickListener)
                event.stopPropagation()
            }
        } // end _outsideClickListener function

        this._collapse =  function _collapse($selector) {

            if ($selector.hasClass(this._opts.expandClass)) {
                this._$body.removeClass(this._opts.bodyExpandClass)
                $selector.removeClass(this._opts.expandClass)
                document.removeEventListener('click', this._outsideClickListener)
            }
        } // end _collapse function

        this._collapseAll =  function _collapseAll(removeBodyClass = true) {

        

            if (this._$body.hasClass(this._opts.bodyExpandClass)) {
                if (removeBodyClass) this._$body.removeClass(this._opts.bodyExpandClass)
                this._$selectors.removeClass(this._opts.expandClass) // collapse all else
                document.removeEventListener('click', this._outsideClickListener);
            }
        }// end _collapseAll function

}

window.onload = function () { 
    var selector = new SimpleSelector();
    selector._init()
    $('body').addClass('transitions');
}
